module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dn_layer_on-ee9be7507559c64cb3c1e3e104a5e254.png";